import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { rrss } from "../data/links";
import kofiIcon from "../assets/img/rrss/rrss-kf.png";
import paypalIcon from "../assets/img/rrss/rrss-pp.png";

export default function Donations() {
  return (
  <>
   <HelmetProvider>
      <Helmet>
        <title>Donaciones | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="donations" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Donaciones</h1>
          <p className="subtitle">Nuestros proyectos actuales son sin ánimo del lucro, pero aceptamos donaciones para poder seguir mejorando e invertirlo en nuevas herramientas.</p>
        </div>
        <div className="content-main">
          <div className="content-items">
            <div className="column-item separator-right">
              <span className="title">Ko-fi</span>
              <img className="icon" alt="Logo de Ko-fi" src={kofiIcon}/>
              <span className="text">Invítanos a un café.</span>
              <a className="btn btn-primary" href={rrss.kf} target="_blank" rel="noopener noreferrer">Ir a Ko-fi</a>
            </div>
            <div className="column-item ">
              <span className="title">Paypal</span>
              <img className="icon" alt="Logo de Paypal" src={paypalIcon}/>
              <span className="text">Dona la cantidad que desees.</span>
              <a className="btn btn-primary" href={rrss.pp} target="_blank" rel="noopener noreferrer">Ir a Paypal</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
